import type { SocialStatAPIResponse } from "@/app/games/(details)/types";
import { DiscordLogo, XLogo } from "../icons";
import { AppleLogo } from "../icons/AppleLogo";
import { GooglePlayLogo } from "../icons/GooglePlayLogo";
import { TelegramLogo } from "../icons/TelegramLogo";
import { TwitchLogo } from "../icons/TwitchLogo";
import { WindowsLogo } from "../icons/WindowsLogo";
import { GlassButton } from "./GlassButton";

export const getPlatformButtons = (
  storeUrls: string[] | undefined,
  gameId?: string,
  gameName?: string,
) =>
  storeUrls?.map((url) => {
    if (url.includes("store.steampowered.com")) {
      return (
        <GlassButton
          target="_blank"
          rel="noopener noreferrer"
          label="Windows"
          subLabel=""
          href={url}
          key={url}
          className="size-10 md:size-12"
          labelsClassName="hidden @3xl:block"
          gameId={gameId}
          gameName={gameName}
          control="SteamPlatform"
        >
          <WindowsLogo className="md:scale-100 scale-90 size-5" />
        </GlassButton>
      );
    }
    if (url.includes("apps.apple.com")) {
      return (
        <GlassButton
          target="_blank"
          rel="noopener noreferrer"
          label="App Store"
          subLabel=""
          href={url}
          key={url}
          className="size-10 md:size-12"
          labelsClassName="hidden @3xl:block"
          gameId={gameId}
          gameName={gameName}
          control="AppStorePlatform"
        >
          <AppleLogo className="md:scale-100 scale-90 size-5" />
        </GlassButton>
      );
    }
    if (url.includes("play.google.com")) {
      return (
        <GlassButton
          target="_blank"
          rel="noopener noreferrer"
          label="Play Store"
          subLabel=""
          href={url}
          key={url}
          className="size-10 md:size-12"
          labelsClassName="hidden @3xl:block"
          gameId={gameId}
          gameName={gameName}
          control="PlayStorePlatform"
        >
          <GooglePlayLogo className="md:scale-100 scale-90 size-5" />
        </GlassButton>
      );
    }
  });

export const getSocialButtons = (
  socials: SocialStatAPIResponse[] | undefined,
  gameId?: string,
  gameName?: string,
) =>
  socials?.map((social) => {
    switch (social.type) {
      case "x":
        return (
          <GlassButton
            key={social.type}
            label="Followers"
            subLabel={social.count.toString()}
            href={`https://x.com/intent/user?user_id=${social.handle}`}
            target="_blank"
            rel="noopener noreferrer"
            className="size-10 md:size-12"
            labelsClassName="hidden @3xl:block"
            gameId={gameId}
            gameName={gameName}
            control="XSocial"
          >
            <XLogo className="md:scale-100 scale-90 size-5" variant="solid" />
          </GlassButton>
        );
      case "discord":
        return (
          <GlassButton
            key={social.type}
            label="Members"
            subLabel={social.count.toString()}
            className="size-10 md:size-12"
            labelsClassName="hidden @3xl:block"
            gameId={gameId}
            gameName={gameName}
            control="DiscordSocial"
          >
            <DiscordLogo className="md:scale-100 scale-90 size-5" />
          </GlassButton>
        );
      case "telegram":
        return (
          <GlassButton
            key={social.type}
            label="Followers"
            subLabel={social.count.toString()}
            className="size-10 md:size-12"
            labelsClassName="hidden @3xl:block"
            gameId={gameId}
            gameName={gameName}
            control="TelegramSocial"
          >
            <TelegramLogo className="md:scale-100 scale-90 size-5" />
          </GlassButton>
        );
      case "twitch":
        return (
          <GlassButton
            key={social.type}
            label="Followers"
            subLabel={social.count.toString()}
            className="size-10 md:size-12"
            labelsClassName="hidden @3xl:block"
            gameId={gameId}
            gameName={gameName}
            control="TwitchSocial"
          >
            <TwitchLogo className="md:scale-100 scale-90 size-5" />
          </GlassButton>
        );
      default:
        return null;
    }
  });
